import React from 'react';

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded shadow-lg max-w-2xl">
        <h1 className="text-3xl font-bold mb-4 text-gray-900">About Neighbourhood.me</h1>
        <p className="text-gray-700">
            Neighbourhood.me was born out of the need to manage Whatsapp groups which are open to a selected group of members.
        </p>
      </div>
    </div>
  );
};

export default AboutPage;